import React from 'react';
import {ChevronLeft, ChevronRight, LogOut} from 'lucide-react';
import {Conversation} from '../utils/types';
import SearchBar from './SearchBar';

interface ChatHeaderProps {
    conversation: Conversation | null;
    sidebarOpen: boolean;
    toggleSidebar: () => void;
    searchQuery: string;
    searchResults: Array<{
        conversationId: number;
        messageId: number;
        content: string;
    }>;
    showSearchResults: boolean;
    onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSearchResultClick: (conversationId: number, messageId: number) => void;
    conversations: Conversation[];
    onCloseConversation?: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
                                                   conversation,
                                                   sidebarOpen,
                                                   toggleSidebar,
                                                   searchQuery,
                                                   searchResults,
                                                   showSearchResults,
                                                   onSearchChange,
                                                   onSearchResultClick,
                                                   conversations,
                                                   onCloseConversation
                                               }) => {
    return (
        <div className="border-b border-gray-200 flex w-full">
            <div className="container mx-auto max-w-4xl h-full">
                <div className="p-4  flex items-center justify-between">
                    <div className="flex items-center">
                        <button
                            className="p-2 rounded-lg text-gray-500 hover:bg-gray-100 mr-2"
                            onClick={toggleSidebar}
                            aria-label={sidebarOpen ? "Hide sidebar" : "Show sidebar"}
                        >
                            {sidebarOpen ? <ChevronLeft size={20}/> : <ChevronRight size={20}/>}
                        </button>
                        <h2 className="text-lg font-semibold">{conversation?.title || 'Alex - Xelacore Data Copilot'}</h2>
                    </div>

                    <div className="flex items-center">
                        <SearchBar
                            placeholder="Search your questions..."
                            value={searchQuery}
                            onChange={onSearchChange}
                            showResults={showSearchResults}
                            searchResults={searchResults}
                            conversations={conversations}
                            onResultClick={onSearchResultClick}
                        />

                        {conversation && onCloseConversation && (
                            <button
                                className="ml-2 p-2 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-red-500"
                                onClick={onCloseConversation}
                                aria-label="Close conversation"
                            >
                                <LogOut size={20}/>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChatHeader;